import { toastr } from 'react-redux-toastr';
import { INCIDENT_RECORD_ENDPOINT } from '../../config/endpoints';
import { DEFAULT_POST_CONFIG, DEFAULT_GET_CONFIG } from '../../config/rest';
import { isErrorResponse } from '../../utils/error-handlers';
import {
  ACTIVITY_INCIDENT_RECORD,
  GET_INCIDENT_RECORD,
  CLEAR_INCIDENT_RECORD,
  FLAG_ACTIVITY_INCIDENT_RECORD,
} from '../types/supervision-control';

const flagActivityIncidentRecord = (flag) => (dispatch) =>
  dispatch({ type: ACTIVITY_INCIDENT_RECORD, payload: flag });

const postIncidentRecord =
  ({
    incidentId,
    incidentDate,
    itineraryId,
    segmentId,
    agencyId,
    answerList,
    incidentRecordType,
  }) =>
  async (dispatch) => {
    try {
      const body = {
        incidentId,
        incidentDate,
        itineraryId,
        segmentId,
        agencyId,
        answerList,
        incidentRecordType,
      };
      dispatch(flagActivityIncidentRecord(true));
      const response = await fetch(INCIDENT_RECORD_ENDPOINT, {
        ...DEFAULT_POST_CONFIG,
        body: JSON.stringify(body),
      });
      await isErrorResponse(response, null, dispatch);
      toastr.success('Éxito', 'El registro de incidente se creó correctamente');
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagActivityIncidentRecord(false));
    }
  };

const clearIncidentRecord = () => (dispatch) =>
  dispatch({ type: CLEAR_INCIDENT_RECORD });

const flagGettingIncidentRecord = (flag) => (dispatch) =>
  dispatch({ type: FLAG_ACTIVITY_INCIDENT_RECORD, payload: flag });

const getItineraryIncidentById =
  ({ incidentRecordId }) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingIncidentRecord(true));
      const response = await fetch(
        `${INCIDENT_RECORD_ENDPOINT}/${incidentRecordId}`,
        {
          ...DEFAULT_GET_CONFIG,
        },
      );
      await isErrorResponse(response, null, dispatch);
      const data = await response.json();
      dispatch({ type: GET_INCIDENT_RECORD, payload: data });
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagGettingIncidentRecord(false));
    }
  };

export {
  flagActivityIncidentRecord,
  postIncidentRecord,
  getItineraryIncidentById,
  clearIncidentRecord,
};
